import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Page = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme.color.primary_200};
`;

const Content = styled.section`
  width: min(100%, 440px);
  padding: 24px;
  text-align: center;
  background: ${({ theme }) => theme.color.primary_100};
  border: 1px solid ${({ theme }) => theme.color.primary_300};
  border-radius: 8px;
`;

const StatusCode = styled.p`
  margin: 0 0 12px;
  color: ${({ theme }) => theme.color.point_y_100};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
`;

const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.color.text_color_100};
  font-size: 20px;
  font-weight: 700;
`;

const Description = styled.p`
  margin: 12px 0 24px;
  color: ${({ theme }) => theme.color.text_color_300};
  font-size: 14px;
  line-height: 1.6;
`;

const HomeLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.color.point_y_100};
  color: ${({ theme }) => theme.color.primary_100};
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.color.point_y_200};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.point_y_100};
    outline-offset: 3px;
  }
`;

const NotFoundPage: React.FC = () => (
  <Page>
    <Content aria-labelledby="not-found-title">
      <StatusCode>404 NOT FOUND</StatusCode>
      <Title id="not-found-title">페이지를 찾을 수 없습니다</Title>
      <Description>
        주소가 변경되었거나 잘못 입력되었습니다. 홈으로 이동해 원하는 메뉴를 다시 선택하세요.
      </Description>
      <HomeLink to="/">홈으로 이동</HomeLink>
    </Content>
  </Page>
);

export default NotFoundPage;
